import React from 'react';
import { Box, styled, Typography, useMediaQuery } from '@mui/material';
import { theme } from 'components';
import PigogoSymbolWrapper from '../PigogoSymbolWrapper';
import CustomContainer from '../CustomContainer';
import { ReactComponent as ExpiredLink } from '../../assets/svgs/expired-link-light.svg';

const BoxStyle = styled(Box)(({ theme }) => ({
  display: 'flex',
  textAlign: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  gap: theme.spacing(2),
  justifyContent: 'space-between',
  padding: theme.spacing(10, 0),
  boxSizing: 'border-box',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 0),
  },
}));

const ErrorExpiredLink = () => {
  return (
    <PigogoSymbolWrapper typeOfWrapper="resetPassword">
      <CustomContainer>
        <BoxStyle>
          <ExpiredLink />
          <Box>
            <Typography variant="smallB" component="h2" color={'#1D2532'}>
              Ληγμένο/λανθασμένο link ανανέωσης κωδικού
            </Typography>
          </Box>
          <Box maxWidth={'608px'}>
            <Typography variant="body2MediumL" component="p" color="#1D2532">
              Το link για την ανανέωση κωδικού έχει πλέον λήξει ή είναι λάθος. Αν θέλεις μπορείς να ζητήσεις ξανά
              ανανέωση κωδικού.
            </Typography>
          </Box>
        </BoxStyle>
      </CustomContainer>
    </PigogoSymbolWrapper>
  );
};

export default ErrorExpiredLink;
